import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import { useParams, useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { FaArchive, FaArrowRight, FaClipboardCheck, FaFolder, FaShieldAlt, FaChartLine } from "react-icons/fa";
import "./ServiceList.css";
import "./styles.css";

const SERVICE_COPY = {
  "Guarda Documental": "Acesse estruturas, pastas e arquivos.",
  "Auditoria": "Entre na esteira de monitoramento, checklist e gestão.",
  "Audit. Patrimonial": "Consulte registros patrimoniais.",
  "Planejamento Estrat\u00e9gico": "Seu planejamento aqui.",
};

const Servicos = () => {
  const navigate = useNavigate();
  const { IDCliente } = useParams();
  const [clienteLogado, setclienteLogado] = useState();
  const [servicelist, setServiceList] = useState([]);

  const { objClienteAberto, setIDProcessoAberto, setBucketAberto } = usePentagovContext();
  const { IDOperador, nome, operador } = useOperador();
  const { authReady } = useAuthContext();

  useEffect(() => {
    if (operador && authReady) {
      const carregarTela = async () => {
        let listaServicos = [];

        try {
          const retorno = await api.get(`/processo/operadorcliente/${IDOperador}/${IDCliente}`);
          if (retorno && retorno.data && Array.isArray(retorno.data)) {
            listaServicos = [...retorno.data];
          } else {
            setBucketAberto(null);
          }
        } catch (error) {
          setBucketAberto(null);
        }

        listaServicos.sort((a, b) => {
          if (!a.descricao) return 1;
          if (!b.descricao) return -1;
          return a.descricao.localeCompare(b.descricao);
        });

        setServiceList(listaServicos);
      };

      carregarTela();
    } else {
      navigate("/");
    }
  }, [operador, authReady, navigate, IDOperador, IDCliente, setBucketAberto]);

  useEffect(() => {
    if (objClienteAberto?.nome && objClienteAberto?.cnpj) {
      setclienteLogado(`${objClienteAberto.nome} - CNPJ: ${objClienteAberto.cnpj}`);
    }
  }, [objClienteAberto]);

  const handleCardClick = (idProcesso, descricao, nomeBucketAws) => {
    setIDProcessoAberto(idProcesso);
    setBucketAberto(nomeBucketAws);
    if (descricao === "Planejamento Estrat\u00e9gico") {
      navigate(`/Planejamento/${IDCliente}/${idProcesso}`);
    } else if (descricao === "Auditoria") {
      navigate(`/AuditoriaSecao/${IDCliente}`);
    } else if (descricao === "Audit. Patrimonial") {
      navigate(`/AuditoriaPatrimonial/${IDCliente}`);
    } else {
      navigate(`/Pastas/${IDCliente}/${idProcesso}/${0}`);
    }
  };

  const ServiceCard = ({ service, onClick }) => {
    let Icon = FaFolder;

    switch (service.descricao) {
      case "Guarda Documental":
        Icon = FaArchive;
        break;
      case "Auditoria":
        Icon = FaClipboardCheck;
        break;
      case "Audit. Patrimonial":
        Icon = FaShieldAlt;
        break;
      case "Planejamento Estrat\u00e9gico":
        Icon = FaChartLine;
        break;
      default:
        Icon = FaFolder;
    }

    return (
      <button type="button" className="service-card" onClick={onClick}>
        <div className="service-card__icon"><Icon /></div>
        <div className="service-card__body">
          <span className="service-card__eyebrow">Modulo</span>
          <h5>{service.descricao}</h5>
          <p>{SERVICE_COPY[service.descricao] || "Abra o modulo para continuar a operacao."}</p>
        </div>
        <span className="service-card__cta">
          Abrir <FaArrowRight />
        </span>
      </button>
    );
  };

  if (!objClienteAberto) {
    return <div>Carregando processos...</div>;
  }

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <div className="page-shell">
          <MenuSuperior userId={String(IDOperador).padStart(6, "0")} userName={nome} cliente={clienteLogado} />

          <section className="page-header-card servicos-hero">
            <span className="page-eyebrow">Modulos do cliente</span>
          </section>

          <section className="page-section-card servicos-list-section">
            <div className="service-list">
              {servicelist.map((service, index) => (
                <div className="service-item" key={index}>
                  <ServiceCard
                    service={service}
                    onClick={() => handleCardClick(service.IDProcesso, service.descricao, service.nomeBucketAws)}
                  />
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Servicos;
